'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _InfoTwoTone = require('./lib/icons/InfoTwoTone');
  
  
  var _default = _InfoTwoTone;
  exports.default = _default;
  module.exports = _default;